import { devUrl } from './dev.env';
import { prodUrl } from './prod.env';
import { testUrl } from './test.env';
import { sitUrl } from './sit.env';
import { uatUrl } from './uat.env';

const getApi = (env) => {
  const apiObj = {
    development: devUrl,
    production: prodUrl,
    test: testUrl,
    sit: sitUrl,
    uat: uatUrl,
  };
  return apiObj[env];
};

export default getApi(process.env.NODE_ENV);
